import { Button, Col, Row, Typography } from 'antd';
import React, { ReactElement } from 'react';
import { currencyFormatter } from '~utilities/formatters';

export default function SelectModalFooter(props: {
    count: number;
    onCancel: () => void;
    onOk: () => void;
    total: number;
}): ReactElement {
    const {
        count,
        onCancel,
        onOk,
        total,
    } = props;

    return (
        <Row align='middle' justify='space-between'>
            <Col>
                <Row style={{ gap: '66px' }}>
                    <Row align='middle' style={{ display: 'flex', gap: '8px' }}>
                        <Col>
                            <Typography.Text>Total Count:</Typography.Text>
                        </Col>
                        <Col>
                            <Typography.Text>{count}</Typography.Text>
                        </Col>
                    </Row>
                    <Row align='middle' style={{ display: 'flex', gap: '8px' }}>
                        <Col>
                            <Typography.Text>Total Amount:</Typography.Text>
                        </Col>
                        <Col>
                            <Typography.Text>{currencyFormatter.format(total)}</Typography.Text>
                        </Col>
                    </Row>
                </Row>
            </Col>
            <Col>
                <Button
                    key='cancel'
                    onClick={onCancel}
                >Cancel</Button>
                <Button
                    disabled={!count}
                    key='submit'
                    type='primary'
                    onClick={onOk}
                >Add</Button>
            </Col>
        </Row>
    );
}